import { Controller } from "@hotwired/stimulus";
import http from "@/http";

export default class IncludeController extends Controller<HTMLDetailsElement> {

  static targets = ['output'];
  static values = { url: String };
  
  declare urlValue: string;
  declare hasUrlValue: boolean;
  declare hasOutputTarget: boolean;
  declare outputTarget: HTMLElement;

  private state?: 'loading' | 'loaded';
  
  public now() {
    if (this.shoudLoadContent()) { 
      this.loadContent();
    } 
  }

  private shoudLoadContent() {
    return this.hasUrlValue && !this.state;
  }

  private loadContent() {
    this.state = 'loading';
    this.application.logDebugActivity(this.identifier, this.loadContent.name, { 'url' : this.urlValue });
    let request = fetch(http.withPageParams(this.urlValue));
    let withToast = http.withToastOnError(request, 'Failed to load details');
    let withSpinner = http.withSpinner(withToast, this.outputTargetWithFallback, 500);
    return withSpinner.then(http.asText).then(this.onContentLoaded).catch(() => this.state = undefined);
  }

  private onContentLoaded = (content: string) => {
    this.state = 'loaded';
    this.outputTargetWithFallback.insertAdjacentHTML('beforeend', content);
  }

  private get outputTargetWithFallback() {
    return this.hasOutputTarget ? this.outputTarget : this.element;
  }
}
